import { shallowEqualArrays } from "~utils";

import { LocalStorageFilterValueTypes } from "./types";

export const isLocalStorageSet = (LSValues: LocalStorageFilterValueTypes) => {
  // Local storage has a value set if any of these are true:
  return (
    // Custom Start has been set
    LSValues.customDates?.start !== undefined ||
    // Custom End has been set
    LSValues.customDates?.end !== undefined ||
    // A date filter has been selected
    LSValues.dateOption !== undefined ||
    // A school was once selected
    LSValues.schools.length !== 0 ||
    // A status was once selected
    LSValues.statuses.length !== 0
  );
};

export const isTempStorageChanged = (
  TempValues: LocalStorageFilterValueTypes,
  LSValues: LocalStorageFilterValueTypes,
) => {
  // Form has been touched if any of these are true:
  return (
    LSValues.customDates?.start !== TempValues.customDates?.start ||
    LSValues.customDates?.end !== TempValues.customDates?.end ||
    LSValues.dateOption !== TempValues.dateOption ||
    !shallowEqualArrays(LSValues.schools, TempValues.schools) ||
    !shallowEqualArrays(LSValues.statuses, TempValues.statuses)
  );
};

export const countActiveFilters = (LSValues: LocalStorageFilterValueTypes) => {
  let filterCount = 0;

  // Count date filters
  if (LSValues.dateOption !== undefined) {
    filterCount++;
  }

  // Count schools
  filterCount += LSValues.schools.length;

  // Count statuses
  filterCount += LSValues.statuses.length;

  return filterCount;
};
